import styled from 'styled-components';
import { uiTokens, UiTone } from './tokens';

const toneBorder = (tone: UiTone) => {
  if (tone === 'positive') {
    return 'rgba(52, 211, 153, 0.45)';
  }
  if (tone === 'negative') {
    return 'rgba(248, 113, 113, 0.45)';
  }
  return 'rgba(148, 163, 184, 0.25)';
};

export const DataTableShell = styled.div<{ tone?: UiTone }>`
  border: 1px solid ${({ tone = 'default' }) => toneBorder(tone)};
  border-radius: 16px;
  overflow: hidden;
  background: ${uiTokens.colors.bgGlass};
  box-shadow: ${uiTokens.shadow.md};
  backdrop-filter: blur(10px);
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: #e2e8f0;
`;

export const DataTableHeadRow = styled.tr<{ tone?: UiTone; sticky?: boolean; topOffset?: number }>`
  background: rgba(15, 23, 42, 0.96);
  border-bottom: 2px solid ${({ tone = 'default' }) => toneBorder(tone)};
  ${({ sticky = false, topOffset = 0 }) =>
    sticky
      ? `
    position: sticky;
    top: ${topOffset}px;
    z-index: 2;
  `
      : ''}
`;

export const DataTableHeadCell = styled.th`
  color: #f8fafc;
  vertical-align: middle;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  padding: 10px;
`;

export const DataTableRow = styled.tr<{ tone?: UiTone; striped?: boolean; index?: number }>`
  background: ${({ tone = 'default', striped = false, index = 0 }) => {
    if (!striped) {
      return 'rgba(10, 10, 12, 0.35)';
    }
    if (tone === 'positive') {
      return index % 2 === 0 ? 'rgba(52, 211, 153, 0.07)' : 'rgba(52, 211, 153, 0.035)';
    }
    if (tone === 'negative') {
      return index % 2 === 0 ? 'rgba(248, 113, 113, 0.07)' : 'rgba(248, 113, 113, 0.035)';
    }
    return index % 2 === 0 ? 'rgba(10, 10, 12, 0.35)' : 'rgba(15, 23, 42, 0.45)';
  }};
`;

export const DataTableCell = styled.td`
  font-size: 14px;
  color: #e2e8f0;
  border: 1px solid rgba(148, 163, 184, 0.2);
  padding: 10px;
  vertical-align: top;
`;
